import { api } from "@/lib/api";

export const PROSPECT_STATUSES = [
    "New",
    "Needs Scan",
    "Scanned",
    "Outreach Drafted",
    "Sent",
    "Replied",
    "Audit Requested",
    "Audit Completed",
    "Subscribed",
    "Not Interested",
];

export const STATUS_COLORS = {
    New: "#9ca3af",
    "Needs Scan": "#0a84ff",
    Scanned: "#0a84ff",
    "Outreach Drafted": "#ff9f0a",
    Sent: "#7cc93c",
    Replied: "#7cc93c",
    "Audit Requested": "#ff9f0a",
    "Audit Completed": "#7cc93c",
    Subscribed: "#7cc93c",
    "Not Interested": "#ff453a",
};

export const listCampaigns = () => api.get("/campaigns").then((r) => r.data);
export const getCampaign = (id) => api.get(`/campaigns/${id}`).then((r) => r.data);
export const createCampaign = (b) => api.post("/campaigns", b).then((r) => r.data);
export const patchCampaign = (id, b) => api.patch(`/campaigns/${id}`, b).then((r) => r.data);
export const deleteCampaign = (id) => api.delete(`/campaigns/${id}`).then((r) => r.data);

// v2 — master campaign
export const getMasterCampaign = () => api.get("/master-campaign").then((r) => r.data);
export const patchMasterCampaign = (b) => api.patch("/master-campaign", b).then((r) => r.data);

// v2 — vertical trackers
export const listVerticalTrackers = () => api.get("/vertical-trackers").then((r) => r.data);
export const getVerticalTracker = (id) => api.get(`/vertical-trackers/${id}`).then((r) => r.data);
export const patchVerticalTracker = (id, b) =>
    api.patch(`/vertical-trackers/${id}`, b).then((r) => r.data);

// v2 — google places
export const googlePlacesStatus = () =>
    api.get("/integrations/google-places/status").then((r) => r.data);
export const findProspects = (cid, body) =>
    api.post(`/campaigns/${cid}/find-prospects`, body || {}).then((r) => r.data);
export const deleteDryRunProspects = (cid, batch_id) =>
    api
        .delete(`/campaigns/${cid}/dry-run-prospects`, {
            params: batch_id ? { batch_id } : {},
        })
        .then((r) => r.data);

// v2 — Phase 4 scoring
export const scoreProspect = (id) =>
    api.post(`/prospects/${id}/score`).then((r) => r.data);
export const scoreAllProspects = (cid) =>
    api.post(`/campaigns/${cid}/score-prospects`).then((r) => r.data);

// v2 — Phase 5 approvals
export const listApprovals = () => api.get("/approvals").then((r) => r.data);
export const approveProspect = (id, body) =>
    api.post(`/prospects/${id}/approve`, body || {}).then((r) => r.data);
export const editProspectDraft = (id, body) =>
    api.post(`/prospects/${id}/edit-draft`, body).then((r) => r.data);
export const rejectProspect = (id, body) =>
    api.post(`/prospects/${id}/reject`, body || {}).then((r) => r.data);
export const markProspectManuallySent = (id) =>
    api.post(`/prospects/${id}/mark-manually-sent`).then((r) => r.data);

export const scoreColor = (n) => {
    if (n == null) return "#6b7280";
    if (n >= 70) return "#7cc93c";
    if (n >= 40) return "#ff9f0a";
    return "#ff453a";
};

export const CAMPAIGN_STATUSES = ["draft", "active", "paused", "archived"];
export const CAMPAIGN_STATUS_COLORS = {
    draft: "#9ca3af",
    active: "#7cc93c",
    paused: "#ff9f0a",
    archived: "#6b7280",
};

export const listProspects = (params) =>
    api.get("/prospects", { params }).then((r) => r.data);
export const createProspect = (b) => api.post("/prospects", b).then((r) => r.data);
export const patchProspect = (id, b) => api.patch(`/prospects/${id}`, b).then((r) => r.data);
export const deleteProspect = (id) => api.delete(`/prospects/${id}`).then((r) => r.data);
export const generateForProspect = (id, kind, opts = {}) => {
    // iter28 — accepts { allow_no_hook, extra_context }. Back-compat: if
    // the third arg is a string, treat it as extra_context.
    const extra = typeof opts === "string" ? { extra_context: opts } : opts;
    return api
        .post(`/prospects/${id}/generate`, { kind, ...extra })
        .then((r) => r.data);
};
export const importProspectsCsv = (campaign_id, csvText) =>
    api
        .post(`/prospects/csv?campaign_id=${encodeURIComponent(campaign_id)}`, csvText, {
            headers: { "Content-Type": "text/csv" },
        })
        .then((r) => r.data);
